import { TurnType } from "./algorithm";
var TurnAbbreviation;
(function (TurnAbbreviation) {
    TurnAbbreviation["Clockwise"] = "";
    TurnAbbreviation["CounterClockwise"] = "'";
    TurnAbbreviation["Double"] = "2";
})(TurnAbbreviation || (TurnAbbreviation = {}));
export var CubeAlgorithmUnit;
(function (CubeAlgorithmUnit) {
    CubeAlgorithmUnit["F"] = "F";
    CubeAlgorithmUnit["U"] = "U";
    CubeAlgorithmUnit["R"] = "R";
    CubeAlgorithmUnit["L"] = "L";
    CubeAlgorithmUnit["D"] = "D";
    CubeAlgorithmUnit["B"] = "B";
    CubeAlgorithmUnit["M"] = "M";
    CubeAlgorithmUnit["E"] = "E";
    CubeAlgorithmUnit["S"] = "S";
    CubeAlgorithmUnit["X"] = "x";
    CubeAlgorithmUnit["Y"] = "y";
    CubeAlgorithmUnit["Z"] = "z";
})(CubeAlgorithmUnit || (CubeAlgorithmUnit = {}));
export const possibleMoves = [
    CubeAlgorithmUnit.F,
    CubeAlgorithmUnit.U,
    CubeAlgorithmUnit.R,
    CubeAlgorithmUnit.L,
    CubeAlgorithmUnit.D,
    CubeAlgorithmUnit.B,
    CubeAlgorithmUnit.M,
    CubeAlgorithmUnit.E,
    CubeAlgorithmUnit.S,
    CubeAlgorithmUnit.X,
    CubeAlgorithmUnit.Y,
    CubeAlgorithmUnit.Z,
];
const cubeRotations = [
    CubeAlgorithmUnit.X,
    CubeAlgorithmUnit.Y,
    CubeAlgorithmUnit.Z,
];
const cubeTurnRegex = /([0-9]+)?([UuFfRrDdLlBbMESxyz])(w)?([2\'])?/g;
/**
 * Takes in an algorithm string and parses the turns from it
 * algorithm string format should be moves separated by a single space
 * (ex. "U R2 L' x")
 *
 * https://www.worldcubeassociation.org/regulations/#article-12-notation
 */
export function parseCubeAlgorithm(algorithm) {
    if (!algorithm) {
        return [];
    }
    let turns = [];
    let match;
    while ((match = cubeTurnRegex.exec(algorithm))) {
        let rawSlices = match[1];
        let rawFace = match[2];
        let outerBlockIndicator = match[3];
        let rawType = match[4] || TurnAbbreviation.Clockwise; // Default to clockwise
        let isLowerCaseMove = rawFace === rawFace.toLowerCase() &&
            cubeRotations.indexOf(rawFace) === -1;
        if (isLowerCaseMove) {
            rawFace = rawFace.toUpperCase();
        }
        let turn = {
            unit: getMove(rawFace),
            turnType: getTurnType(rawType),
            slices: isLowerCaseMove ? 2 : getSlices(rawSlices, outerBlockIndicator),
        };
        turns.push(turn);
    }
    return turns;
}
function getSlices(rawSlices, outerBlockIndicator) {
    if (outerBlockIndicator && !rawSlices) {
        return 2;
    }
    else if (!outerBlockIndicator && rawSlices) {
        throw new Error(`Invalid move: Cannot specify num slices if outer block move indicator 'w' is not present`);
    }
    else if (!outerBlockIndicator && !rawSlices) {
        return 1;
    }
    else {
        const intValue = parseInt(rawSlices);
        if (intValue > 1) {
            return intValue;
        }
        throw new Error(`Invalid outer block move (${intValue}) must be greater than 1`);
    }
}
function getMove(rawFace) {
    if (possibleMoves.indexOf(rawFace) < 0) {
        throw new Error(`Invalid move (${rawFace}): Possible turn faces are [U R F L D B M E S x y z]`);
    }
    else
        return rawFace;
}
function getTurnType(rawType) {
    switch (rawType) {
        case TurnAbbreviation.Clockwise:
            return TurnType.Clockwise;
        case TurnAbbreviation.CounterClockwise:
            return TurnType.CounterClockwise;
        case TurnAbbreviation.Double:
            return TurnType.Double;
        default:
            throw new Error(`Invalid move modifier (${rawType})`);
    }
}
